const permissions = {
    userSystemPermissions: null,
    currentAppUserPermissions: null
};

export default permissions;
